import apiClient from '../apiClient';
import { GET_TEMPLATE_TRANSPORTATION_UNIT_DATA_URL } from '../apiUrl';

const getTemplateTransportationUnitApi = () => {
  return apiClient.get(GET_TEMPLATE_TRANSPORTATION_UNIT_DATA_URL);
};

export default getTemplateTransportationUnitApi;
